export default "__VITE_ASSET__CXpT_EcC__"